/**
 * PageShell — Wrapper que mostra skeleton ou conteúdo com fade-in
 */
import { useState, useEffect } from 'preact/hooks';
import { PageLoading } from './PageLoading';
import { TableSkeleton } from './TableSkeleton';
import { CardSkeleton } from './CardSkeleton';
import { ListSkeleton } from './ListSkeleton';
import { T } from '../../styles/tokens';

interface PageShellProps {
  loading: boolean;
  skeleton?: 'page' | 'table' | 'cards' | 'list';
  children: any;
}

export function PageShell({ loading, skeleton = 'page', children }: PageShellProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!loading) {
      const t = setTimeout(() => setVisible(true), 20);
      return () => clearTimeout(t);
    }
    setVisible(false);
  }, [loading]);

  if (loading) {
    switch (skeleton) {
      case 'table': return <TableSkeleton />;
      case 'cards': return <CardSkeleton />;
      case 'list': return <ListSkeleton />;
      default: return <PageLoading />;
    }
  }

  return (
    <div style={{
      opacity: visible ? 1 : 0,
      transition: `opacity ${T.transitionSlow}`,
    }}>
      {children}
    </div>
  );
}
